/**
 * Created by Ning Jiang on 11/23/2016.
 */

import {IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import {BetWinMode} from "@nolimitcity/slot-game/bin/core/gametype/BetWinMode";
import {SpinMode} from "@nolimitcity/slot-game/bin/core/gametype/SpinMode";
import {IReelSets} from "@nolimitcity/slot-game/bin/core/reel/reelset/IReelSets";
import {IStackedReelSymbolsConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {
    CustomLayerScaleOptions,
    LayerScaleOption,
    ScaleMethod,
    ScaleTarget
} from "@nolimitcity/slot-game/bin/core/stage/LayerScaleOption";
import {IDeviceDependentConfig} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import {IWinRatios, WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {IGameTweakerConfig} from "@nolimitcity/slot-game/bin/dev/tweaker/GameTweaker";
import {Back, Ease} from "gsap";
import {HarlequinGameAssets} from "./HarlequinGameAssets";
import {IHarlequinLayerConfig} from "./stage/IHarlequinLayerConfig";
import {IHarlequinSymbolStates} from "./symbols/HarlequinReelSymbol";

export class HarlequinGameConfig implements IGameConfig {

    public static instance:HarlequinGameConfig = new HarlequinGameConfig();

    BROWSER_FPS:number = 30;

    GAME_WIDTH:number = 1280;
    GAME_HEIGHT:number = 720;

    DEFAULT_LAYER_SCALE_OPTION:IDeviceDependentConfig<LayerScaleOption> = {
        desktop : {landscape : LayerScaleOption.REELS_FIT_STAGE},
        mobile : {
            landscape : LayerScaleOption.REELS_FIT_STAGE,
            portrait : LayerScaleOption.REELS_FIT_WINDOW
        }
    };

    public static customOptions:CustomLayerScaleOptions = {
        frame : {x : 0, y : 0, width : 720, height : 720},
        placement : {
            desktop : {
                landscape : {x : 0.5, y : 0.5}
            },
            mobile : {
                landscape : {x : 0.5, y : 0.5},
                portrait : {x : 0.5, y : 1}
            }
        },
    };

    LAYERS:IHarlequinLayerConfig = {
        BACKGROUND : {
            name : "background",
            scaleOption : LayerScaleOption.FIT_WINDOW,
            customOptions : {
                frame : {x : 0, y : 0, width : 720, height : 720}
            }
        },
        BLUE_BACKGROUND : {
            name : "blueBackground",
            scaleOption : LayerScaleOption.FIT_WINDOW,
            customOptions : {
                frame : {x : 0, y : 0, width : 720, height : 720}
            }
        },
        RED_BACKGROUND : {
            name : "redBackground",
            scaleOption : LayerScaleOption.FIT_WINDOW,
            customOptions : {
                frame : {x : 0, y : 0, width : 720, height : 720}
            }
        },
        GREEN_BACKGROUND : {
            name : "greenBackground",
            scaleOption : LayerScaleOption.FIT_WINDOW,
            customOptions : {
                frame : {x : 0, y : 0, width : 720, height : 720}
            }
        },
        REEL_BACKGROUND : {
            name : "reelBackground"
        },
        SYMBOLS : {name : "symbols"},
        HIGH_SYMBOLS : {name : "highSymbols"},
        REEL_ATTENTION : {name : "reelAttention"},
        PLUS_ONE : {name : "plusOne"},
        BET_LINES : {
            name : "betLines"
            /*,
            scaleOption: {
                desktop : {landscape : LayerScaleOption.FIT_WINDOW},
                mobile : {
                    landscape : LayerScaleOption.FIT_WINDOW,
                    portrait : LayerScaleOption.REELS_FIT_WINDOW
                }
            }*/
        },
        HARLEQUIN_WALKER : {name : "harlequinWalker"},
        HARLEY_BET_LINES : {
            name : "harleyBetLines",
            customOptions : {
                target : ScaleTarget.WINDOW,
                method : ScaleMethod.FIT,
                frame : {x : 0, y : 0, width : 720, height : 720},
                placement : {x : 0.5, y : 0.5}
            }
        },
        BET_LINES_MP : {
            name : "betLinesMp",
            customOptions : {
                target : ScaleTarget.WINDOW,
                method : ScaleMethod.FIT,
                frame : {x : 0, y : 0, width : 720, height : 720},
                placement : {x : 0.5, y : 0.5}
            }
        },
        NEAR_WIN : {
            name : "nearWin",
            scaleOption : {
                desktop : {
                    landscape : LayerScaleOption.REELS_FIT_WINDOW
                },
                mobile : {
                    landscape : LayerScaleOption.REELS_FIT_WINDOW,
                    portrait : LayerScaleOption.REELS_FIT_WINDOW
                }
            }
        },
        SIGNS : {name : "signs"},
        COLLECTOR : {name : "collector"},
        COLLECTOR_FS : {name : "collectorFs"},
        WIN_PRESENTATIONS : {name : "winPresentations"},
        // FOREGROUND : {name: "foreground"},
        BIG_WIN_FADE : {
            name : "bigWinFade",
            scaleOption : {
                desktop : {landscape : LayerScaleOption.FIT_WINDOW},
                mobile : {
                    landscape : LayerScaleOption.FIT_WINDOW,
                    portrait : LayerScaleOption.REELS_FIT_WINDOW
                }
            }
        },
        BIG_WIN_CU : {
            name : "bigWinCu",
            scaleOption : {
                desktop : {landscape : LayerScaleOption.FIT_WINDOW},
                mobile : {
                    landscape : LayerScaleOption.FIT_WINDOW,
                    portrait : LayerScaleOption.REELS_FIT_WINDOW
                }
            }
        },
        BIG_WIN : {
            name : "bigWin",
            scaleOption : {
                desktop : {landscape : LayerScaleOption.FIT_WINDOW},
                mobile : {
                    landscape : LayerScaleOption.FIT_WINDOW,
                    portrait : LayerScaleOption.REELS_FIT_WINDOW
                }
            }
        },
        BONUS_INTRO : {
            name : "bonusIntro",
            scaleOption : LayerScaleOption.FIT_WINDOW,
            customOptions : {
                target : ScaleTarget.WINDOW,
                method : ScaleMethod.FIT,
                frame : {x : 0, y : 0, width : 720, height : 720},
                placement : {x : 0.5, y : 0.5}
            }
        },
        RESPIN_OUTRO : {name : "respinOutro", scaleOption : LayerScaleOption.FIT_WINDOW},
        RESPIN_OUTRO_ANIMATION : {name : "respinOutroAnimation"},
        FS_OUTRO : {
            name : "fsOutroScreen", customOptions : {
                target : ScaleTarget.WINDOW,
                method : ScaleMethod.FIT,
                frame : {x : 0, y : 0, width : 720, height : 720},
                placement : {x : 0.5, y : 0.5}
            }
        },
        WIN_COUNT_UP : {
            name : "winCountUp",
            scaleOption : LayerScaleOption.FIT_WINDOW,
            customOptions : {
                frame : {x : 0, y : 0, width : 720, height : 720}
            }
        },
        INTRO : {
            name : "introScreen", scaleOption : LayerScaleOption.FIT_WINDOW, customOptions : {
                target : ScaleTarget.WINDOW,
                method : ScaleMethod.FIT,
                frame : {x : 0, y : 0, width : 720, height : 720},
                placement : {x : 0.5, y : 0.5}
            }
        },
        FS_INTRO : {
            name : "fsIntroScreen", customOptions : {
                target : ScaleTarget.WINDOW,
                method : ScaleMethod.FIT,
                frame : {x : 0, y : 0, width : 720, height : 720},
                placement : {x : 0.5, y : 0.5}
            }
        },
        TWEAK_MODULE : {name : "tweakModule", scaleOption : LayerScaleOption.FIT_WINDOW}
    };

    BET_WIN_MODE:BetWinMode = BetWinMode.BET_LINE;
    SPIN_MODE:SpinMode = SpinMode.SPIN;

    REEL_AREA_POS_X:number = 280;
    REEL_AREA_POS_Y:number = 240;
    REEL_AREA_WIDTH:number = 720;
    REEL_AREA_HEIGHT:number = 200 * 3;

    SYMBOL_STATES:IHarlequinSymbolStates = {
        normal : {
            prio : 0,
            keyword : "normal",
            texturesCreator : (symName:string, stateKey:string) => {
                return HarlequinGameAssets.getSymbolStateTextures(symName);
            }
        },
        spin : {
            prio : 1,
            keyword : "spin",
            texturesCreator : (symName:string, stateKey:string) => {
                return HarlequinGameAssets.getSymbolStateTextures(symName, stateKey);
            }
        },
        nudge : {
            prio : 2,
            keyword : "nudge",
            texturesCreator : (symName:string, stateKey:string) => {
                // TEMP: Reason is texture is replaced by spine anim
                if(["W*0", "W*1", "W*2", "W", "W0", "W1", "W2"].indexOf(symName) < 0) {
                    return HarlequinGameAssets.getSymbolStateTextures(symName); // TODO: didn't solve the missing resource
                } else {
                    return [new PIXI.Sprite().texture];
                }
            }
        },
        noWin : {
            prio : 3,
            keyword : "noWin",
            texturesCreator : (symName:string, stateKey:string) => {
                return HarlequinGameAssets.getSymbolStateTextures(symName);
            }
        },
        win : {
            prio : 4,
            keyword : "win",
            texturesCreator : (symName:string, stateKey:string) => {
                if(["W*0", "W*1", "W*2", "W", "W1", "W0", "W2", "W3"].indexOf(symName) < 0 /*&& ["L1", "L2", "L3", "L4", "M1", "M2", "M3", "M4", "M5"].indexOf(symName) < 0*/) {
                    return HarlequinGameAssets.getSymbolStateTextures(symName);
                } else {
                    return [new PIXI.Sprite().texture];
                }
            }
        },
        hidden : {
            prio : 5,
            keyword : "hidden"
        },
    };
    SYMBOL_WIDTH:number = 144;
    SYMBOL_HEIGHT:number = 200;
    SYMBOL_BOTTOM_PADDING:number = 0;

    REELS_NUM:number = 5;
    SPACE_BETWEEN_REELS:number = 0;
    REEL_DISPLAY_POSITIONS:[number, number][] = [
        [this.SYMBOL_WIDTH * 0.5, 0],
        [this.SYMBOL_WIDTH * 1.5 + this.SPACE_BETWEEN_REELS, 0],
        [this.SYMBOL_WIDTH * 2.5 + this.SPACE_BETWEEN_REELS * 2, 0],
        [this.SYMBOL_WIDTH * 3.5 + this.SPACE_BETWEEN_REELS * 3, 0],
        [this.SYMBOL_WIDTH * 4.5 + this.SPACE_BETWEEN_REELS * 4, 0]];
    SYMBOLS_NUM_IN_REEL:[number, number, number, number, number] = [2, 1, 3, 1, 5];
    // [3, 1, 4, 1, 0]

    STACKED_SYMBOLS:IStackedReelSymbolsConfig = {
        "W" : {
            totalNum : 3
        }
    };


    REEL_SPIN_TIME:number = 0.9;
    REEL_FAST_SPIN_SPIN_TIME:number = 0.2;

    REEL_SPIN_START_SYMBOL_CHANGE_TO_SPIN_STATE_DURATION:number = 0.2;
    REEL_SPIN_START_SYMBOL_CHANGE_TO_SPIN_STATE_DELAY:number = 0.3;
    REEL_SPIN_START_EASE:Ease = Back.easeIn.config(4);
    REEL_SPIN_STOP_SYMBOL_CHANGE_FROM_SPIN_STATE_DURATION:number = 0.2;
    REEL_SPIN_STOP_SYMBOL_CHANGE_FROM_SPIN_STATE_DELAY:number = 0;
    REEL_SPIN_STOP_ELASTIC_CONFIG:[number, number] = [1.5, 0.95];
    REEL_SPIN_QUICK_STOP_ELASTIC_CONFIG:[number, number] = [1.2, 0.75];

    REEL_SPIN_START_SPEED:number = 0.3;
    REEL_SPIN_SPIN_SPEED:number = 0.04;
    REEL_NEAR_WIN_SPIN_SPEED:number = 0.03;
    REEL_SPIN_STOP_SPEED:number = 0.5;
    REEL_SPIN_QUICK_STOP_SPEED:number = 0.5;

    REEL_STOP_DELAY:number = 0.3;
    REEL_QUICK_STOP_DELAY:number = 0.1;
    REEL_NEAR_WIN_STOP_DELAY:number = 1.5; // TODO: is in effect, but must be synced with the other NW functionality !! Reelstop sound !!fetch

    REEL_SETS:IReelSets = {
        "BASE_REELSET" : [ // TODO: TEMPORARY!
            ["M1", "L1", "L3", "M1", "L3", "M5", "M2", "L2", "M4", "M2", "M3", "L4", "M5"],

            ["M1", "L1", "L3", "W", "W", "W", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M2", "L2", "M4", "S",
                "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4"],
            ["M1", "L1", "L3", "W", "W", "W", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M2", "L2", "M4", "S",
                "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4"],
            ["M1", "L1", "L3", "W", "W", "W", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M2", "L2", "M4", "S",
                "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4"],

            ["M1", "L1", "L3", "M1", "L3", "M5", "M2", "L2", "M4", "M2", "M3", "L4", "M5"]
        ],

        "NORMAL" : [ // TODO: TEMPORARY!
            ["M1", "L1", "L3", "M1", "L3", "M5", "M2", "L2", "M4", "M2", "M3", "L4", "M5"],

            ["M1", "L1", "L3", "W", "W", "W", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M2", "L2", "M4", "S",
                "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4"],
            ["M1", "L1", "L3", "W", "W", "W", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M2", "L2", "M4", "S",
                "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4"],
            ["M1", "L1", "L3", "W", "W", "W", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M2", "L2", "M4", "S",
                "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4"],

            ["M1", "L1", "L3", "M1", "L3", "M5", "M2", "L2", "M4", "M2", "M3", "L4", "M5"]
        ],

        "WILD_RESPIN_REELSET" : [ // TODO: TEMPORARY!
            ["M1", "L1", "L3", "M1", "L3", "M5", "M2", "L2", "M4", "M2", "M3", "L4", "M5"],

            ["M1", "L1", "L3", "W", "W", "W", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M2", "L2", "M4", "S",
                "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4"],
            ["M1", "L1", "L3", "W", "W", "W", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M2", "L2", "M4", "S",
                "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4"],
            ["M1", "L1", "L3", "W", "W", "W", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M2", "L2", "M4", "S",
                "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4"],

            ["M1", "L1", "L3", "M1", "L3", "M5", "M2", "L2", "M4", "M2", "M3", "L4", "M5"]
        ],

        "FREESPIN_REELSET" : [ // TODO: TEMPORARY!
            ["M1", "L1", "L3", "M1", "L3", "M5", "M2", "L2", "M4", "M2", "M3", "L4", "M5"],

            ["M1", "L1", "L3", "W", "W", "W", "M2", "L2", "M4", "S2", "M3", "L4", "M5", "M2", "L2", "M4", "S2", "M3", "L4", "M5", "M2", "L2", "M4", "S2",
                "L4", "M5", "M2", "L2", "M4", "S2", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S2", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S2", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4"],
            ["M1", "L1", "L3", "W", "W", "W", "M2", "L2", "M4", "S2", "M3", "L4", "M5", "M2", "L2", "M4", "S2", "M3", "L4", "M5", "M2", "L2", "M4", "S2",
                "L4", "M5", "M2", "L2", "M4", "S2", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S2", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S2", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4"],
            ["M1", "L1", "L3", "W", "W", "W", "M2", "L2", "M4", "S2", "M3", "L4", "M5", "M2", "L2", "M4", "S2", "M3", "L4", "M5", "M2", "L2", "M4", "S2",
                "L4", "M5", "M2", "L2", "M4", "S2", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S2", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S2", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4"],

            ["M1", "L1", "L3", "M1", "L3", "M5", "M2", "L2", "M4", "M2", "M3", "L4", "M5"]
        ],

        "WILD_RESPIN_FS_REELSET" : [ // TODO: TEMPORARY!
            ["M1", "L1", "L3", "M1", "L3", "M5", "M2", "L2", "M4", "M2", "M3", "L4", "M5"],

            ["M1", "L1", "L3", "W", "W", "W", "M2", "L2", "M4", "S2", "M3", "L4", "M5", "M2", "L2", "M4", "S2", "M3", "L4", "M5", "M2", "L2", "M4", "S2",
                "L4", "M5", "M2", "L2", "M4", "S2", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S2", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S2", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4"],
            ["M1", "L1", "L3", "W", "W", "W", "M2", "L2", "M4", "S2", "M3", "L4", "M5", "M2", "L2", "M4", "S2", "M3", "L4", "M5", "M2", "L2", "M4", "S2",
                "L4", "M5", "M2", "L2", "M4", "S2", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S2", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S2", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4"],
            ["M1", "L1", "L3", "W", "W", "W", "M2", "L2", "M4", "S2", "M3", "L4", "M5", "M2", "L2", "M4", "S2", "M3", "L4", "M5", "M2", "L2", "M4", "S2",
                "L4", "M5", "M2", "L2", "M4", "S2", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S2", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4",
                "L4", "M5", "M2", "L2", "M4", "S2", "M3", "L4", "M5", "M1", "L1", "L3", "M1", "L1", "L3", "M3", "L4", "M5", "M2", "L2", "M4"],

            ["M1", "L1", "L3", "M1", "L3", "M5", "M2", "L2", "M4", "M2", "M3", "L4", "M5"]
        ]
    };

    WIN_RATIOS:IWinRatios = {
        normalWin : [
            {
                ratio : 0,
                text : "Tiny Win",
                duration : 0,
                type : WinRatioType.TINY
            },
            {
                ratio : 1.5,
                text : "Small Win",
                duration : 0,
                type : WinRatioType.SMALL
            },
            {
                ratio : 3,
                text : "Medium Win",
                duration : 0.4,
                type : WinRatioType.MEDIUM
            },
            {
                ratio : 5,
                text : "Large Win",
                duration : 0.8,
                type : WinRatioType.LARGE
            }
        ],
        bigWin : [
            {
                ratio : 15,
                text : "Big Win",
                duration : 4.583,
                type : WinRatioType.BIG_WIN
            },
            {
                ratio : 25,
                text : "Mega Win",
                duration : 4.444,
                type : WinRatioType.MEGA_WIN

            },
            {
                ratio : 50,
                text : "Super Mega Win",
                duration : 4.414,
                type : WinRatioType.SUPER_MEGA_WIN
            }
        ]
    };

    GAME_TWEAKER_CONFIG:IGameTweakerConfig = {
        layer : this.LAYERS.TWEAK_MODULE.name,
        baseWindowWidth : 400,
        moduleHeight : 32,
        copyAllButtonText : "Copy All",
        buttonSkinIdle : "button",
        buttonSkinOver : "button",
        buttonSkinDown : "button",
        buttonSkinDisabled : "button-disabled"
    };
    PERFORMANCE_LOGGER:boolean = true;

    WIN_BELOW_STAKE: boolean = false; // #323

    private constructor() {
        if(HarlequinGameConfig.instance) {
            throw new Error("HarlequinGameConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}